import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { shallowEqual } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';

import './App.module.scss';
import { ROUTES } from 'data/routes';
import { Login } from 'features';
import { AuthWrapper, BaseLayout, LocaleProvider, StoreWrapper } from 'layouts';
import { useAppSelector } from 'store/hooks';
import { selectCurrentUser } from 'store/user/selectors';
import PageNotFound from 'components/PageNotFound';
import DashboardWrapper from 'layouts/DashboardWrapper';
import { PerformanceIndicators } from 'screens/performanceIndicators/PerformanceIndicators';

function App() {
  const currentUser = useAppSelector(selectCurrentUser, shallowEqual);
  
  return (
    <BaseLayout>
      <StoreWrapper>
        <AuthWrapper>
          <LocaleProvider>
            <CssBaseline />
            <BrowserRouter basename={process.env.REACT_APP_INDEX_FILE_PATH}>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<DashboardWrapper />}>
                {!!currentUser && <Route index element={<Navigate to={ROUTES.PERFORMANCE_INDICATORS} />} />}
                  <Route path={ROUTES.DASHBOARD} element={<>Dashboard</>} />
                  <Route path={ROUTES.PERFORMANCE_INDICATORS} element={<PerformanceIndicators />} />
                  <Route path="*" element={<PageNotFound />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </LocaleProvider>
        </AuthWrapper>
      </StoreWrapper>
    </BaseLayout>
  );
}

export default App;
